import React, { useState,  } from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import purify from "dompurify";
import './PhotoShootDenyPopup.css';
import Config from '../../constants/Config';

const PhotoShootDenyPopup = React.memo(
    ({      
        onClose,
        message=`スケジュール撮影時刻の前後１０分間は、
						<br>遠隔撮影できません。`, 
    }) => {

        if( !Config.RELEASE_MODE ){
            console.log('PhotoShootDenyPopup Render !');
        }
        
        const [isDragging, setIsDragging] = useState(false);

        //Handle drag popup        
        const [dragStartPosition, setDragStartPosition] = useState({ x: 0, y: 0 });

        const handleStart = (e) => {
            setIsDragging(true);
            setDragStartPosition({ x: e.clientX, y: e.clientY });
        };

        const handleDrag = (e) => {
            const distance = Math.sqrt(
            Math.pow(e.clientX - dragStartPosition.x, 2) +
            Math.pow(e.clientY - dragStartPosition.y, 2)
            );
        
            if (distance > 5) {
                setIsDragging(true);
            }
        };

        const handleStop = () => {            
            setIsDragging(false);
        };

        const closePopup = () => {            
            if (!isDragging) {
                onClose();
            }
        };
     
        return (
            <div className="popup-wrapper" id="confirm_popup_wrapper" onClick={closePopup}>
                <Draggable
                    handle=".popup"
                    positionOffset={{ x: '-50%', y: '-50%' }}
                    onStart={handleStart}
                    onDrag={handleDrag}
                    onStop={handleStop}
                    cancel="textarea, input, .no-drag, button"
                >
                    <div className="popup" id="confirm_popup" onClick={(e) => e.stopPropagation()}>
                        <div className="popup-content" id="photo_shoot_confirm" style={{ background: 'white' }}>
                            <div className="confirm-content-icon">
                                <span className="icon-img"/>
                            </div>
                            <div className="confirm-content-message" >
                                <div className="set_master_name_measure">
                                    <p dangerouslySetInnerHTML={{ __html:purify.sanitize(message) }}></p>
                                </div>
                            </div>
                            <div className="confirm-content-button">                                
                                <button type="button" id="confirm-ok" className="mod-btn__round small" onClick={onClose}>
                                    閉じる
                                </button>                        
                            </div>           
                        </div>
                    </div>
                </Draggable>
            </div>
        );
    },
);


PhotoShootDenyPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    message: PropTypes.string,
};

export default PhotoShootDenyPopup;
